import React from "react";
import Play from "../modules/Play/Play"

export default function PlayPage() {
    return <Play />;
}
